import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createSmokerRateOverrideRule } from '../../../api/plan-smoker-rate-override-rules-api'
import type {
  CreatePlanSmokerRateOverrideRuleRequestDto,
  PlanSmokerRateOverrideRuleResponseDto,
} from '../../../api/dto/plan-smoker-rate-override-rules.dto'
import { SMOKER_RATE_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanSmokerRateOverride/hooks/useGetSmokerRateOverrideRules'

export function useCreateSmokerRateOverrideRule() {
  const queryClient = useQueryClient()

  return useMutation<
    PlanSmokerRateOverrideRuleResponseDto,
    unknown,
    CreatePlanSmokerRateOverrideRuleRequestDto
  >({
    mutationFn: (body) => createSmokerRateOverrideRule(body),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [SMOKER_RATE_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
